import React, { useEffect, useRef } from 'react';

function PopupLayer({ title, onClose, popupKey, layerOptions }) {
  const contentsRef = useRef(null);
  const popupLayerRef = useRef(null);
  const scrollTop = useRef(0);

  useEffect(() => {
    if (TMON.popup)
      TMON.popup.render(popupKey, contentsRef.current, layerOptions);
      
    // MW일 때 팝업이 열리면 body의 스크롤과 우하단에 고정된 버튼들을 숨긴다.
    if (TMON.sDevice === 'MW') {
      const elHtml = document.querySelector('html');
      scrollTop.current = elHtml.scrollTop;

      // IOS MW에서 팝업뒤 영역이 스크롤 되는 이슈가 있어 html 영역 스크롤 되지 않도록 처리
      elHtml.style = 'overflow: hidden; width: 100%; position: fixed';
      document.querySelector('.tlbarwp').style.display = 'none';
    }

    // 각 레이어간의 z-index 우선순위를 설정한다.
    TMON.oApp.oUtil.setPopupLayerZIndex(popupLayerRef.current);
  }, [layerOptions, popupKey]);

  const handleClose = e => {
    onClose(e);

    // 닫을 때 숨겼던 것들을 다시 보여준다.
    if (TMON.sDevice === 'MW') {
      const elHtml = document.querySelector('html');
      elHtml.style.removeProperty('overflow');
      elHtml.style.removeProperty('position');
      elHtml.style.removeProperty('width');
      elHtml.scrollTop = scrollTop.current;
      document.querySelector('.tlbarwp').style.display = 'block';
    }
  };

  return (
    <section className={`popup popup_${popupKey}`} ref={popupLayerRef}>
      <header className="popup_header">
        <h3 className="popup_header_title">{title}</h3>
        <button
          type="button"
          className="popup_header_close"
          aria-label="팝업닫기"
          onClick={handleClose}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
          >
            <path
              fill="#30343B"
              fillRule="evenodd"
              d="M0 0h.87v.87H0V0zm.87.87h.87v.87H.87V.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87H20V20h-.87v-.87zM20 0v.87h-.87V0H20zm-.87.87v.87h-.87V.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-1.739 1.739v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869H1.74v-.87h.87zm-.869.869v.87H.87v-.87h.87zm-.87.87V20H0v-.87h.87z"
            />
          </svg>
        </button>
      </header>
      <div className="popup_contents" ref={contentsRef} />
    </section>
  );
}

export default PopupLayer;
